module.exports = __webpack_public_path__ + "img/logo-header.9fb34ee4.png";